/* oxlint-disable */
import { useRouter } from 'next/navigation';

import {
  Card, CardHeader, CardBody, CardFooter, Divider,
} from '@heroui/react';

import { useAuthStore } from '@/stores/userStore';
import { userUIStore } from '@/stores/userUIStore';
import { HButton } from '@/stories/atoms/buttons/mainButton/Button';

import { formatMoneyWithCurrency, moneyFormat } from '@/utils/money';

import { core } from '@/features/header/finance/localization/texts';

const ValuesCard = () => {
  const { balance, account } = useAuthStore();
  const { toggleDepositModal } = userUIStore();

  const router = useRouter();
  const handleDeposit = () => {
    if (account?.contingencies?.deposits) {
      router.push('/?cont=4');
    } else {
      toggleDepositModal();
    }
  };
  return (
    <Card className="max-w-[340px] bg-hbackground rounded-2xl">
      <CardHeader className="flex text-hprimary-500 font-bold gap-3">
        <p>
          Saldo total:
          <span className="ms-1 text-hprimary-900">
            {moneyFormat(balance[0]?.amount.toFixed(2) ?? '0')}
          </span>
        </p>
      </CardHeader>
      <Divider />
      <CardBody>
        <div className="text-nowrap">
          {balance.filter((_:any, index:number) => { return index > 0; }).map((item:any) => {
            return (
              <div className="flex justify-between items-center gap-x-12 w-full text-sm font-text" key={`${item.amount}-${item.description}`}>
                <span className="text-primary-900 font-medium">{formatMoneyWithCurrency(item.amount, account?.currency)}</span>
                <div className="flex justify-end items-center text-primary-900 text-xs">
                  <span>{item.description}</span>
                </div>
              </div>
            );
          })}
        </div>
      </CardBody>
      <Divider />
      <CardFooter className="flex justify-end">
        <HButton
          label={core.deposit}
          size="small"
          mode="secondary"
          disabled={false}
          onPress={handleDeposit}
        />
      </CardFooter>
    </Card>
  );
};
export default ValuesCard;
